import { message } from "antd";
import { EmailTemplateLayoutFormCard } from "./components/EmailTemplateLayoutForm";
import { useMutation } from "@tanstack/react-query";
import { EmailTemplateLayout } from "@rumble-it/common-lib/types/models/EmailTemplateLayout.interface";
import { createEmailTemplateLayout } from "../../../lib/api/resources/emailTemplateLayouts";
import { useNavigate } from "react-router-dom";

export const EmailTemplateLayoutCreate = () => {
  const navigate = useNavigate();

  const createEmailTemplateLayoutMutation = useMutation({
    mutationFn: (data: EmailTemplateLayout) => createEmailTemplateLayout(data),
    onSuccess: () => {
      navigate("/email-templates/layouts");
      message.success("Email Template Layout succesvol aangemaakt");
    },
  });

  return (
    <div>
      <EmailTemplateLayoutFormCard
        mutation={createEmailTemplateLayoutMutation}
      />
    </div>
  );
};
